export interface Currency {
  code: string;
  label: string;
  symbol: string;
}

export const CURRENCIES: Currency[] = [
  { code: 'USD', label: 'US Dollar', symbol: '$' },
  { code: 'EUR', label: 'Euro', symbol: '€' },  
  { code: 'INR', label: 'Indian Rupee', symbol: '₹' },
  { code: 'CHF', label: 'Swiss Franc', symbol: 'CHF' },
  { code: 'CNY', label: 'Chinese Yuan', symbol: '¥' },
  { code: 'JPY', label: 'Japanese Yen', symbol: '¥' },
  { code: 'GBP', label: 'British Pound', symbol: '£' },
  { code: 'AUD', label: 'Australian Dollar', symbol: 'A$' },
  { code: 'CAD', label: 'Canadian Dollar', symbol: 'C$' },
  { code: 'HKD', label: 'Hong Kong Dollar', symbol: 'HK$' },
  { code: 'SGD', label: 'Singapore Dollar', symbol: 'S$' },
  { code: 'KRW', label: 'South Korean Won', symbol: '₩' },
  { code: 'SEK', label: 'Swedish Krona', symbol: 'kr' },
  { code: 'NOK', label: 'Norwegian Krone', symbol: 'kr' },
  { code: 'NZD', label: 'New Zealand Dollar', symbol: 'NZ$' },
  { code: 'AED', label: 'UAE Dirham', symbol: 'د.إ' },
  { code: 'AFN', label: 'Afghan Afghani', symbol: '؋' },
  { code: 'ALL', label: 'Albanian Lek', symbol: 'L' },
  { code: 'AMD', label: 'Armenian Dram', symbol: '֏' },
  { code: 'ANG', label: 'Netherlands Antillean Guilder', symbol: 'ƒ' },
  { code: 'AOA', label: 'Angolan Kwanza', symbol: 'Kz' },
  { code: 'ARS', label: 'Argentine Peso', symbol: '$' },
  { code: 'AWG', label: 'Aruban Florin', symbol: 'ƒ' },
  { code: 'AZN', label: 'Azerbaijani Manat', symbol: '₼' },
  { code: 'BAM', label: 'Bosnia-Herzegovina Convertible Mark', symbol: 'КМ' },
  { code: 'BBD', label: 'Barbadian Dollar', symbol: '$' },
  { code: 'BDT', label: 'Bangladeshi Taka', symbol: '৳' },
  { code: 'BGN', label: 'Bulgarian Lev', symbol: 'лв' },
  { code: 'BHD', label: 'Bahraini Dinar', symbol: '.د.ب' },
  { code: 'BIF', label: 'Burundian Franc', symbol: 'FBu' },
  { code: 'BMD', label: 'Bermudan Dollar', symbol: '$' },
  { code: 'BND', label: 'Brunei Dollar', symbol: '$' },
  { code: 'BOB', label: 'Bolivian Boliviano', symbol: '$b' },
  { code: 'BRL', label: 'Brazilian Real', symbol: 'R$' },
  { code: 'BSD', label: 'Bahamian Dollar', symbol: '$' },
  { code: 'BTN', label: 'Bhutanese Ngultrum', symbol: 'Nu.' },
  { code: 'BWP', label: 'Botswanan Pula', symbol: 'P' },
  { code: 'BYN', label: 'Belarusian Ruble', symbol: 'Br' },
  { code: 'BZD', label: 'Belize Dollar', symbol: 'BZ$' },
  { code: 'CDF', label: 'Congolese Franc', symbol: 'FC' },
  { code: 'CLP', label: 'Chilean Peso', symbol: '$' },
  { code: 'COP', label: 'Colombian Peso', symbol: '$' },
  { code: 'CRC', label: 'Costa Rican Colón', symbol: '₡' },
  { code: 'CUC', label: 'Cuban Convertible Peso', symbol: '$' },
  { code: 'CUP', label: 'Cuban Peso', symbol: '₱' },
  { code: 'CVE', label: 'Cape Verdean Escudo', symbol: '$' },
  { code: 'CZK', label: 'Czech Republic Koruna', symbol: 'Kč' },
  { code: 'DJF', label: 'Djiboutian Franc', symbol: 'Fdj' },
  { code: 'DKK', label: 'Danish Krone', symbol: 'kr' },
  { code: 'DOP', label: 'Dominican Peso', symbol: 'RD$' },
  { code: 'DZD', label: 'Algerian Dinar', symbol: 'دج' },
  { code: 'EGP', label: 'Egyptian Pound', symbol: '£' },
  { code: 'ERN', label: 'Eritrean Nakfa', symbol: 'Nfk' },
  { code: 'ETB', label: 'Ethiopian Birr', symbol: 'Br' },
  { code: 'FJD', label: 'Fijian Dollar', symbol: '$' },
  { code: 'FKP', label: 'Falkland Islands Pound', symbol: '£' },
  { code: 'GEL', label: 'Georgian Lari', symbol: '₾' },
  { code: 'GGP', label: 'Guernsey Pound', symbol: '£' },
  { code: 'GHS', label: 'Ghanaian Cedi', symbol: '¢' },
  { code: 'GIP', label: 'Gibraltar Pound', symbol: '£' },
  { code: 'GMD', label: 'Gambian Dalasi', symbol: 'D' },
  { code: 'GNF', label: 'Guinean Franc', symbol: 'FG' },
  { code: 'GTQ', label: 'Guatemalan Quetzal', symbol: 'Q' },
  { code: 'GYD', label: 'Guyanaese Dollar', symbol: '$' },
  { code: 'HNL', label: 'Honduran Lempira', symbol: 'L' },
  { code: 'HRK', label: 'Croatian Kuna', symbol: 'kn' },
  { code: 'HTG', label: 'Haitian Gourde', symbol: 'G' },
  { code: 'HUF', label: 'Hungarian Forint', symbol: 'Ft' },
  { code: 'IDR', label: 'Indonesian Rupiah', symbol: 'Rp' },
  { code: 'ILS', label: 'Israeli New Sheqel', symbol: '₪' },
  { code: 'IMP', label: 'Manx Pound', symbol: '£' },
  { code: 'IQD', label: 'Iraqi Dinar', symbol: 'ع.د' },
  { code: 'IRR', label: 'Iranian Rial', symbol: '﷼' },
  { code: 'ISK', label: 'Icelandic Króna', symbol: 'kr' },
  { code: 'JEP', label: 'Jersey Pound', symbol: '£' },
  { code: 'JMD', label: 'Jamaican Dollar', symbol: 'J$' },
  { code: 'JOD', label: 'Jordanian Dinar', symbol: 'JD' },
  { code: 'KES', label: 'Kenyan Shilling', symbol: 'KSh' },
  { code: 'KGS', label: 'Kyrgystani Som', symbol: 'лв' },
  { code: 'KHR', label: 'Cambodian Riel', symbol: '៛' },
  { code: 'KMF', label: 'Comorian Franc', symbol: 'CF' },
  { code: 'KPW', label: 'North Korean Won', symbol: '₩' },
  { code: 'KWD', label: 'Kuwaiti Dinar', symbol: 'KD' },
  { code: 'KYD', label: 'Cayman Islands Dollar', symbol: '$' },
  { code: 'KZT', label: 'Kazakhstani Tenge', symbol: '₸' },
  { code: 'LAK', label: 'Laotian Kip', symbol: '₭' },
  { code: 'LBP', label: 'Lebanese Pound', symbol: '£' },
  { code: 'LKR', label: 'Sri Lankan Rupee', symbol: '₨' },
  { code: 'LRD', label: 'Liberian Dollar', symbol: '$' },
  { code: 'LSL', label: 'Lesotho Loti', symbol: 'M' },
  { code: 'LYD', label: 'Libyan Dinar', symbol: 'LD' },
  { code: 'MAD', label: 'Moroccan Dirham', symbol: 'MAD' },
  { code: 'MDL', label: 'Moldovan Leu', symbol: 'lei' },
  { code: 'MGA', label: 'Malagasy Ariary', symbol: 'Ar' },
  { code: 'MKD', label: 'Macedonian Denar', symbol: 'ден' },
  { code: 'MMK', label: 'Myanma Kyat', symbol: 'K' },
  { code: 'MNT', label: 'Mongolian Tugrik', symbol: '₮' },
  { code: 'MOP', label: 'Macanese Pataca', symbol: 'MOP$' },
  { code: 'MRU', label: 'Mauritanian Ouguiya', symbol: 'UM' },
  { code: 'MUR', label: 'Mauritian Rupee', symbol: '₨' },
  { code: 'MVR', label: 'Maldivian Rufiyaa', symbol: 'Rf' },
  { code: 'MWK', label: 'Malawian Kwacha', symbol: 'MK' },
  { code: 'MXN', label: 'Mexican Peso', symbol: '$' },
  { code: 'MYR', label: 'Malaysian Ringgit', symbol: 'RM' },
  { code: 'MZN', label: 'Mozambican Metical', symbol: 'MT' },
  { code: 'NAD', label: 'Namibian Dollar', symbol: '$' },
  { code: 'NGN', label: 'Nigerian Naira', symbol: '₦' },
  { code: 'NIO', label: 'Nicaraguan Córdoba', symbol: 'C$' },
  { code: 'NPR', label: 'Nepalese Rupee', symbol: '₨' },
  { code: 'OMR', label: 'Omani Rial', symbol: '﷼' },
  { code: 'PAB', label: 'Panamanian Balboa', symbol: 'B/.' },
  { code: 'PEN', label: 'Peruvian Nuevo Sol', symbol: 'S/.' },
  { code: 'PGK', label: 'Papua New Guinean Kina', symbol: 'K' },
  { code: 'PHP', label: 'Philippine Peso', symbol: '₱' },
  { code: 'PKR', label: 'Pakistani Rupee', symbol: '₨' },
  { code: 'PLN', label: 'Polish Zloty', symbol: 'zł' },
  { code: 'PYG', label: 'Paraguayan Guarani', symbol: 'Gs' },
  { code: 'QAR', label: 'Qatari Rial', symbol: '﷼' },
  { code: 'RON', label: 'Romanian Leu', symbol: 'lei' },
  { code: 'RSD', label: 'Serbian Dinar', symbol: 'Дин.' },
  { code: 'RUB', label: 'Russian Ruble', symbol: '₽' },
  { code: 'RWF', label: 'Rwandan Franc', symbol: 'R₣' },
  { code: 'SAR', label: 'Saudi Riyal', symbol: '﷼' },
  { code: 'SBD', label: 'Solomon Islands Dollar', symbol: '$' },
  { code: 'SCR', label: 'Seychellois Rupee', symbol: '₨' },
  { code: 'SDG', label: 'Sudanese Pound', symbol: 'LS' },
  { code: 'SHP', label: 'Saint Helena Pound', symbol: '£' },
  { code: 'SLE', label: 'Sierra Leonean Leone', symbol: 'Le' },
  { code: 'SOS', label: 'Somali Shilling', symbol: 'S' },
  { code: 'SRD', label: 'Surinamese Dollar', symbol: '$' },
  { code: 'STN', label: 'São Tomé and Príncipe Dobra', symbol: 'Db' },
  { code: 'SVC', label: 'Salvadoran Colón', symbol: '$' },
  { code: 'SYP', label: 'Syrian Pound', symbol: '£' },
  { code: 'SZL', label: 'Swazi Lilangeni', symbol: 'E' },
  { code: 'THB', label: 'Thai Baht', symbol: '฿' },
  { code: 'TJS', label: 'Tajikistani Somoni', symbol: 'SM' },
  { code: 'TMT', label: 'Turkmenistani Manat', symbol: 'T' },
  { code: 'TND', label: 'Tunisian Dinar', symbol: 'د.ت' },
  { code: 'TOP', label: 'Tongan Paʻanga', symbol: 'T$' },
  { code: 'TRY', label: 'Turkish Lira', symbol: '₺' },
  { code: 'TTD', label: 'Trinidad and Tobago Dollar', symbol: 'TT$' },
  { code: 'TVD', label: 'Tuvaluan Dollar', symbol: '$' },
  { code: 'TWD', label: 'New Taiwan Dollar', symbol: 'NT$' },
  { code: 'TZS', label: 'Tanzanian Shilling', symbol: 'TSh' },
  { code: 'UAH', label: 'Ukrainian Hryvnia', symbol: '₴' },
  { code: 'UGX', label: 'Ugandan Shilling', symbol: 'USh' },
  { code: 'UYU', label: 'Uruguayan Peso', symbol: '$U' },
  { code: 'UZS', label: 'Uzbekistan Som', symbol: 'лв' },
  { code: 'VED', label: 'Venezuelan Bolívar Digital', symbol: 'Bs' },
  { code: 'VES', label: 'Venezuelan Bolívar Soberano', symbol: 'Bs' },
  { code: 'VND', label: 'Vietnamese Dong', symbol: '₫' },
  { code: 'VUV', label: 'Vanuatu Vatu', symbol: 'VT' },
  { code: 'WST', label: 'Samoan Tala', symbol: 'WS$' },
  { code: 'XAF', label: 'CFA Franc BEAC', symbol: 'FCFA' },
  { code: 'XCD', label: 'East Caribbean Dollar', symbol: '$' },
  { code: 'XDR', label: 'Special Drawing Rights', symbol: 'SDR' },
  { code: 'XOF', label: 'CFA Franc BCEAO', symbol: 'CFA' },
  { code: 'XPF', label: 'CFP Franc', symbol: '₣' },
  { code: 'YER', label: 'Yemeni Rial', symbol: '﷼' },
  { code: 'ZAR', label: 'South African Rand', symbol: 'R' },
  { code: 'ZMW', label: 'Zambian Kwacha', symbol: 'ZK' },
  { code: 'ZWL', label: 'Zimbabwean Dollar', symbol: 'Z$' },
];

export type CurrencyCode = (typeof CURRENCIES)[number]['code'];

export const CURRENCY_CODES: CurrencyCode[] = CURRENCIES.map((c) => c.code);
